/* ==========================================================================
   Pool Busters — Fiberglass Design Centre
   assets/pb-fiberglass.js
   --------------------------------------------------------------------------
   Vanilla ES2018. No dependencies, no framework, no polyfills required for
   any browser Shopify supports. ~14 KB unminified.

   SECURITY NOTE
   Every value that originates from a customer or from the data file is written
   with textContent / setAttribute. innerHTML is never used with dynamic data.
   The only innerHTML in this file writes a static, developer-authored SVG
   constant (PB_SHELL_SVG) that contains no interpolation.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------------------------------------------------------------- utils */

  var $  = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  };

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  var REDUCED = window.matchMedia &&
                window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Static, developer-authored mark. Contains no dynamic data. */
  var PB_SHELL_SVG =
    '<svg viewBox="0 0 160 100" role="presentation" focusable="false">' +
    '<rect x="12" y="18" width="136" height="64" rx="3" fill="none" ' +
    'stroke="currentColor" stroke-width="1.1"/>' +
    '<rect x="24" y="30" width="112" height="40" rx="2" fill="none" ' +
    'stroke="currentColor" stroke-width="0.7" opacity="0.55"/>' +
    '<path d="M24 62h28" stroke="currentColor" stroke-width="0.7" opacity="0.55"/>' +
    '<path d="M24 54h28" stroke="currentColor" stroke-width="0.7" opacity="0.55"/>' +
    '</svg>';

  /* ------------------------------------------------------- scroll reveals */

  function initReveals() {
    var items = $$('.pbfg-reveal');
    if (!items.length) return;
    if (REDUCED || !('IntersectionObserver' in window)) {
      items.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (n) { io.observe(n); });
  }

  /* ------------------------------------------------------ focus trapping */

  function trapFocus(container, onEscape) {
    var SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), ' +
                   'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    function onKey(e) {
      if (e.key === 'Escape') { onEscape(); return; }
      if (e.key !== 'Tab') return;
      var nodes = $$(SELECTOR, container).filter(function (n) {
        return n.offsetParent !== null || n === document.activeElement;
      });
      if (!nodes.length) return;
      var first = nodes[0];
      var last  = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    container.addEventListener('keydown', onKey);
    return function () { container.removeEventListener('keydown', onKey); };
  }

  /* =======================================================================
     FAVOURITES STORE

     A place to keep designs, not a basket. Nothing here is an order and
     nothing here is a final choice — which pool actually gets built is worked
     out with Pool Busters in person, once someone has seen the property.

     So there is no "primary", no radio button, no one-of-these-wins. The
     customer collects what they like; the enquiry passes the whole list on as
     the starting point for that conversation.
     ======================================================================= */

  var STORE_KEY = 'pbfg:favourites';
  var LEGACY_KEY = 'pbfg:selection';

  var Favourites = {
    items: [],
    listeners: [],

    load: function () {
      try {
        var raw = window.sessionStorage.getItem(STORE_KEY) ||
                  window.sessionStorage.getItem(LEGACY_KEY);
        if (!raw) return;
        var saved = JSON.parse(raw);
        /* Earlier sessions stored either a single model or a shortlist
           object. Read both rather than dropping what someone had saved. */
        if (Array.isArray(saved)) this.items = saved;
        else if (saved && saved.items) this.items = saved.items;
        else if (saved && saved.id) this.items = [saved];
      } catch (err) { this.items = []; }
      return this.items;
    },

    save: function () {
      try {
        if (this.items.length) window.sessionStorage.setItem(STORE_KEY, JSON.stringify(this.items));
        else window.sessionStorage.removeItem(STORE_KEY);
        window.sessionStorage.removeItem(LEGACY_KEY);
      } catch (err) { /* private mode — favourites stay in memory only */ }
    },

    has: function (id) {
      for (var i = 0; i < this.items.length; i++) if (this.items[i].id === id) return true;
      return false;
    },

    add: function (model) {
      if (!model || this.has(model.id)) return;
      this.items.push(model);
      this.save(); this.emit();
    },

    remove: function (id) {
      this.items = this.items.filter(function (m) { return m.id !== id; });
      this.save(); this.emit();
    },

    toggle: function (model) {
      if (this.has(model.id)) { this.remove(model.id); return false; }
      this.add(model); return true;
    },

    clear: function () { this.items = []; this.save(); this.emit(); },

    label: function (m) { return m.brand + ' ' + m.name; },

    on: function (fn) { this.listeners.push(fn); fn(this); },

    emit: function () {
      var self = this;
      this.listeners.forEach(function (fn) { fn(self); });
    }
  };

  /* Polite live region shared by the whole page. */
  var liveRegion;
  function announce(message) {
    if (!liveRegion) {
      liveRegion = el('p', 'pbfg-visually-hidden');
      liveRegion.setAttribute('role', 'status');
      liveRegion.setAttribute('aria-live', 'polite');
      document.body.appendChild(liveRegion);
    }
    liveRegion.textContent = '';
    window.setTimeout(function () { liveRegion.textContent = message; }, 60);
  }

  /* One definition of how a stored filename becomes a URL, shared by the
     catalogue and the gallery. Reads the config at call time, so the preview
     can point it somewhere else after load. */
  function filesUrl(name) {
    if (!name) return '';
    /* A value that is already a URL is used as-is. Lets a merchant point a
       single model at an outside asset without touching filesBase, and lets
       the local preview inline its imagery. */
    if (/^(https?:|data:|\/\/|\/)/.test(name)) return name;
    var base = (window.PB_FG_CONFIG || {}).filesBase;
    if (!base) return '';
    if (base.charAt(base.length - 1) !== '/') base += '/';
    return base + name;
  }

  /* =======================================================================
     CATALOGUE
     ======================================================================= */

  function initCatalogue() {
    var root = $('[data-pbfg-catalogue]');
    if (!root || !window.PB_FG_MODELS) return;

    var MODELS  = window.PB_FG_MODELS;
    var CONFIG  = window.PB_FG_CONFIG || {};
    var LABELS  = window.PB_FG_FEATURE_LABELS || {};
    var SIZES   = window.PB_FG_SIZE_LABELS || {};

    var grid       = $('[data-pbfg-grid]', root);
    var empty      = $('[data-pbfg-empty]', root);
    var countNode  = $('[data-pbfg-count]', root);
    /* There are several "clear" affordances (toolbar, result bar, empty state).
       They must all stay in sync and all be clickable. */
    var clearBtns  = $$('[data-pbfg-clear]', root);
    var searchInp  = $('[data-pbfg-search]', root);
    var sizeSel    = $('[data-pbfg-size]', root);
    var collSel    = $('[data-pbfg-collection]', root);
    var brandSel   = $('[data-pbfg-brand]', root);
    var tabs       = $$('[data-pbfg-tab]', root);
    var featureBox = $('[data-pbfg-features]', root);

    var state = { brand: 'all', q: '', size: '', collection: '', features: [] };

    /* ---- populate the collection + feature controls from the data ------- */

    function buildCollectionOptions() {
      if (!collSel) return;
      var pool = state.brand === 'all'
        ? MODELS
        : MODELS.filter(function (m) { return m.brand === state.brand; });
      var seen = {};
      var list = [];
      pool.forEach(function (m) {
        if (m.collection && !seen[m.collection]) { seen[m.collection] = 1; list.push(m.collection); }
      });
      list.sort();
      var keep = state.collection;
      collSel.textContent = '';
      collSel.appendChild(new Option('All collections', ''));
      list.forEach(function (c) { collSel.appendChild(new Option(c, c)); });
      collSel.value = list.indexOf(keep) > -1 ? keep : '';
      state.collection = collSel.value;
    }

    function buildFeatureChips() {
      if (!featureBox) return;
      var used = {};
      MODELS.forEach(function (m) {
        (m.tags || []).forEach(function (t) { used[t] = 1; });
      });
      var wrap = el('div', 'pbfg-chips');
      Object.keys(LABELS).forEach(function (key) {
        if (!used[key]) return;
        var label = el('label', 'pbfg-chip');
        var input = el('input');
        input.type  = 'checkbox';
        input.value = key;
        input.setAttribute('data-pbfg-feature', '');
        var span = el('span', null, LABELS[key]);
        label.appendChild(input);
        label.appendChild(span);
        wrap.appendChild(label);
      });
      featureBox.appendChild(wrap);
    }

    /* ---- image resolution --------------------------------------------- */

    /* Shopify Files shortcut: filesBase + "<model-id>.jpg". Saves pasting 84
       full CDN URLs by hand — set the base once, name the files by model id. */
    /* An EMPTY `file` means "no approved thumbnail exists for this model" and
       must resolve to the generated plan view.

       It must NOT quietly fall through to `fileSpec`. Several models ship a
       dimensioned drawing but no clean shell render, and the agreed treatment
       for those is the plan view — a drawing full of measurement callouts
       reads badly at card size and breaks the grid. `fileSpec` still shows in
       the details drawer, which is where it belongs.

       Set preferSpecDiagram to deliberately swap the whole catalogue over to
       dimensioned drawings. */
    function imageFor(model) {
      if (model.cdn) return { url: model.cdn, kind: 'photo' };

      var viaFiles  = filesUrl(model.file);
      var shellFile = filesUrl(model.fileSpec);

      if (CONFIG.preferSpecDiagram && shellFile) return { url: shellFile, kind: 'diagram' };
      if (viaFiles) return { url: viaFiles, kind: 'photo' };

      if (CONFIG.preferSpecDiagram && model.cdnSpec) return { url: model.cdnSpec, kind: 'diagram' };
      if (CONFIG.useManufacturerUrls) {
        if (!CONFIG.preferSpecDiagram && model.src) return { url: model.src, kind: 'photo' };
        if (model.spec) return { url: model.spec, kind: 'diagram' };
        if (model.src)  return { url: model.src,  kind: 'photo' };
      }
      return null;
    }

    function mediaNode(model, sizesAttr) {
      var img = imageFor(model);
      var box = el('div', 'pbfg-card__media' + (img && img.kind === 'diagram' ? ' pbfg-card__media--diagram' : ''));

      if (img) {
        var node = el('img');
        node.src = img.url;
        node.alt = model.brand + ' ' + model.name + ' fiberglass pool — ' +
                   (img.kind === 'diagram' ? 'shell dimensions diagram' : 'installed pool') +
                   ', ' + model.dims;
        node.loading = 'lazy';
        node.decoding = 'async';
        if (sizesAttr) node.sizes = sizesAttr;
        node.addEventListener('error', function () {
          box.textContent = '';
          box.appendChild(shellNode(model));
        }, { once: true });
        box.appendChild(node);
      } else {
        box.appendChild(shellNode(model));
      }

      if (model.status === 'new') {
        box.appendChild(el('span', 'pbfg-card__badge', 'New model'));
      }
      return box;
    }

    /* When no approved photograph is available, draw an accurate plan view
       from the published dimensions rather than repeating one generic
       graphic. Falls back to a neutral mark if the dimensions cannot be
       parsed for some reason. */
    function shellNode(model) {
      var s = el('div', 'pbfg-shell');

      var plan = null;
      if (model && window.PB_FG_PLANVIEW) {
        try { plan = window.PB_FG_PLANVIEW.build(model); } catch (err) { plan = null; }
      }

      if (plan) {
        s.classList.add('pbfg-shell--plan');
        s.appendChild(plan);
        s.appendChild(el('span', 'pbfg-shell__label', 'Plan view · to published ratio'));
        return s;
      }

      s.innerHTML = PB_SHELL_SVG; /* static constant — no interpolation */
      s.appendChild(el('span', 'pbfg-shell__label', 'Representative shell'));
      return s;
    }

    /* ---- card ---------------------------------------------------------- */

    function buildCard(model) {
      var li   = el('li');
      var card = el('article', 'pbfg-card');
      card.setAttribute('data-model-id', model.id);

      card.appendChild(mediaNode(model, '(min-width: 1100px) 30vw, (min-width: 600px) 45vw, 92vw'));

      var body = el('div', 'pbfg-card__body');
      body.appendChild(el('p', 'pbfg-card__brand', model.brand));

      var h3 = el('h3', 'pbfg-card__name');
      h3.id = 'pbfg-name-' + model.id;
      h3.textContent = model.name;
      body.appendChild(h3);

      body.appendChild(el('p', 'pbfg-card__collection',
        model.collection || model.shape || '—'));

      var dl = el('dl', 'pbfg-specs');
      function pair(term, value) {
        if (!value) return;
        var wrap = el('div');
        wrap.appendChild(el('dt', null, term));
        wrap.appendChild(el('dd', null, value));
        dl.appendChild(wrap);
      }
      pair('Dimensions', model.dims);
      pair('Depth', model.depth);
      pair('Shape', model.shape);
      pair('Volume', model.gallons ? model.gallons + ' gal' : '');
      body.appendChild(dl);

      if (model.tags && model.tags.length) {
        var tagWrap = el('div', 'pbfg-tags');
        model.tags.slice(0, 4).forEach(function (t) {
          if (LABELS[t]) tagWrap.appendChild(el('span', 'pbfg-tag', LABELS[t]));
        });
        if (tagWrap.childNodes.length) body.appendChild(tagWrap);
      }

      /* `note` is customer-facing and renders. Production notes to ourselves go in
         `internalNote`, which nothing on this page ever reads — that is the whole
         point of the split. Do not collapse the two fields back together. */
      if (model.note) body.appendChild(el('p', 'pbfg-card__note', model.note));

      var actions = el('div', 'pbfg-card__actions');

      var selectBtn = el('button', 'pbfg-btn pbfg-btn--sm');
      selectBtn.type = 'button';
      selectBtn.setAttribute('data-pbfg-select', model.id);
      selectBtn.setAttribute('aria-describedby', h3.id);
      selectBtn.textContent = 'Select';
      actions.appendChild(selectBtn);

      var detailsBtn = el('button', 'pbfg-details');
      detailsBtn.type = 'button';
      detailsBtn.setAttribute('data-pbfg-details', model.id);
      detailsBtn.setAttribute('aria-describedby', h3.id);
      detailsBtn.textContent = 'Details';
      actions.appendChild(detailsBtn);

      body.appendChild(actions);
      card.appendChild(body);
      li.appendChild(card);
      return li;
    }

    /* ---- filtering ----------------------------------------------------- */

    function matches(model) {
      if (state.brand !== 'all' && model.brand !== state.brand) return false;
      if (state.size && model.size !== state.size) return false;
      if (state.collection && model.collection !== state.collection) return false;

      if (state.features.length) {
        var tags = model.tags || [];
        for (var i = 0; i < state.features.length; i++) {
          if (tags.indexOf(state.features[i]) === -1) return false;
        }
      }

      if (state.q) {
        /* Former manufacturer names are searchable so a customer holding an
           older brochure still finds the pool, without cluttering the card. */
        var hay = (model.name + ' ' + model.brand + ' ' + (model.collection || '') + ' ' +
                   (model.shape || '') + ' ' + (model.features || []).join(' ') + ' ' +
                   (model.aliases || []).join(' ')).toLowerCase();
        if (hay.indexOf(state.q) === -1) return false;
      }
      return true;
    }

    /* Launch pass: the catalogue renders a page at a time. 84 cards at once
       made the phone page ~70,000px tall. Filters reset the page; "Show more"
       appends the next twelve. */
    var PAGE = 12, shown = PAGE;
    var moreBtn = $('[data-pbfg-more]', root);
    if (moreBtn) moreBtn.addEventListener('click', function () { shown += PAGE; render(true); });

    function render(keep) {
      var results = MODELS.filter(matches);
      if (!keep) shown = PAGE;

      grid.textContent = '';
      var frag = document.createDocumentFragment();
      results.slice(0, shown).forEach(function (m) { frag.appendChild(buildCard(m)); });
      grid.appendChild(frag);
      if (moreBtn) {
        var left = results.length - Math.min(shown, results.length);
        moreBtn.hidden = left <= 0;
        moreBtn.textContent = left > 0 ? 'Show ' + Math.min(PAGE, left) + ' more designs (' + left + ' remaining)' : '';
      }

      if (countNode) {
        countNode.textContent = '';
        var strong = el('strong', null, String(results.length));
        countNode.appendChild(strong);
        countNode.appendChild(document.createTextNode(
          ' ' + (results.length === 1 ? 'design' : 'designs') +
          (state.brand === 'all' ? '' : ' from ' + state.brand)
        ));
      }

      if (empty) empty.hidden = results.length !== 0;

      var dirty = !!(state.q || state.size || state.collection || state.features.length);
      clearBtns.forEach(function (btn) {
        /* The empty-state button lives inside a container that is itself
           toggled, so it stays visible whenever that state is shown. */
        if (btn.closest('[data-pbfg-empty]')) return;
        btn.hidden = !dirty;
      });

      paintSelected();
      announce(results.length + ' ' + (results.length === 1 ? 'design' : 'designs') + ' shown');
    }

    function paintSelected() {
      $$('.pbfg-card', grid).forEach(function (card) {
        var mine = Favourites.has(card.getAttribute('data-model-id'));
        card.classList.toggle('is-selected', mine);
        var btn = $('[data-pbfg-select]', card);
        if (btn) {
          btn.textContent = mine ? 'Saved' : 'Save to favourites';
          btn.setAttribute('aria-pressed', mine ? 'true' : 'false');
        }
      });
    }

    /* ---- events -------------------------------------------------------- */

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        state.brand = tab.getAttribute('data-pbfg-tab');
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        if (brandSel) brandSel.value = state.brand === 'all' ? '' : state.brand;
        buildCollectionOptions();
        render();
      });

      /* Arrow-key roving between tabs, per WAI-ARIA tabs pattern. */
      tab.addEventListener('keydown', function (e) {
        var i = tabs.indexOf(tab);
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft')  next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home')       next = tabs[0];
        if (e.key === 'End')        next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); next.focus(); next.click(); }
      });
    });

    if (brandSel) {
      brandSel.addEventListener('change', function () {
        state.brand = brandSel.value || 'all';
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected',
            t.getAttribute('data-pbfg-tab') === state.brand ? 'true' : 'false');
        });
        buildCollectionOptions();
        render();
      });
    }

    var searchTimer;
    if (searchInp) {
      searchInp.addEventListener('input', function () {
        window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(function () {
          state.q = searchInp.value.trim().toLowerCase();
          render();
        }, 180);
      });
    }

    if (sizeSel) {
      sizeSel.addEventListener('change', function () { state.size = sizeSel.value; render(); });
    }
    if (collSel) {
      collSel.addEventListener('change', function () { state.collection = collSel.value; render(); });
    }

    if (featureBox) {
      featureBox.addEventListener('change', function (e) {
        if (!e.target.matches('[data-pbfg-feature]')) return;
        state.features = $$('[data-pbfg-feature]', featureBox)
          .filter(function (i) { return i.checked; })
          .map(function (i) { return i.value; });
        render();
      });
    }

    clearBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.q = ''; state.size = ''; state.collection = ''; state.features = [];
        if (searchInp) searchInp.value = '';
        if (sizeSel) sizeSel.value = '';
        $$('[data-pbfg-feature]', featureBox || document).forEach(function (i) { i.checked = false; });
        buildCollectionOptions();
        render();
        announce('Filters cleared');
        if (searchInp) searchInp.focus();
      });
    });

    /* Select + details, delegated so re-rendering never loses handlers. */
    grid.addEventListener('click', function (e) {
      var sel = e.target.closest('[data-pbfg-select]');
      if (sel) {
        var model = findModel(sel.getAttribute('data-pbfg-select'));
        if (!model) return;
        var added = Favourites.toggle(model);
        var label = Favourites.label(model);
        var n = Favourites.items.length;
        announce(added
          ? label + ' saved. ' + n + (n === 1 ? ' design in your favourites.' : ' designs in your favourites.')
          : label + ' removed from your favourites.');
        return;
      }
      var det = e.target.closest('[data-pbfg-details]');
      if (det) openDrawer(findModel(det.getAttribute('data-pbfg-details')), det);
    });

    function findModel(id) {
      for (var i = 0; i < MODELS.length; i++) if (MODELS[i].id === id) return MODELS[i];
      return null;
    }

    /* ---- details drawer ------------------------------------------------ */

    var drawer = $('[data-pbfg-drawer]');
    var releaseTrap = null;
    var lastTrigger = null;

    function openDrawer(model, trigger) {
      if (!model || !drawer) return;
      lastTrigger = trigger || null;

      var title = $('[data-pbfg-drawer-title]', drawer);
      var body  = $('[data-pbfg-drawer-body]', drawer);
      var foot  = $('[data-pbfg-drawer-select]', drawer);

      if (title) title.textContent = model.brand + ' · ' + model.name;

      body.textContent = '';

      var fig = el('div', 'pbfg-drawer__figure');
      var media = mediaNode(model, '(min-width: 600px) 520px, 92vw');
      while (media.firstChild) fig.appendChild(media.firstChild);
      body.appendChild(fig);

      if (model.collection) body.appendChild(el('p', 'pbfg-card__collection', model.collection));

      var dl = el('dl', 'pbfg-specs');
      [['Manufacturer', model.brand], ['Model', model.name],
       ['Dimensions', model.dims], ['Depth', model.depth],
       ['Shape', model.shape], ['Volume', model.gallons ? model.gallons + ' gal' : '']
      ].forEach(function (row) {
        if (!row[1]) return;
        var w = el('div');
        w.appendChild(el('dt', null, row[0]));
        w.appendChild(el('dd', null, row[1]));
        dl.appendChild(w);
      });
      body.appendChild(dl);

      if (model.features && model.features.length) {
        body.appendChild(el('h4', 'pbfg-h3', 'Features'));
        var ul = el('ul', 'pbfg-brand__list');
        model.features.forEach(function (f) { ul.appendChild(el('li', null, f)); });
        body.appendChild(ul);
      }

      /* `note` is customer-facing and renders. Production notes to ourselves go in
         `internalNote`, which nothing on this page ever reads — that is the whole
         point of the split. Do not collapse the two fields back together. */
      if (model.note) body.appendChild(el('p', 'pbfg-card__note', model.note));

      /* The card outside shows one thing only: the shell, so eighty-odd cards
         read as one grid. Everything else about the model lives in here — the
         dimensioned drawing first, then the manufacturer's photography of the
         shell in the ground, which is what people actually want to see once a
         shape has caught their eye. */
      var moreShots = [];
      var dimUrl = filesUrl(model.fileSpec) || model.cdnSpec;
      if (dimUrl) moreShots.push({ url: dimUrl, label: 'Dimensioned drawing', fit: 'contain' });
      (model.filesExtra || []).forEach(function (f) {
        var u = filesUrl(f);
        if (u) moreShots.push({ url: u, label: 'Installed', fit: 'cover' });
      });

      if (moreShots.length) {
        var strip = el('div', 'pbfg-drawer__more');
        moreShots.forEach(function (shot) {
          var fig = el('figure', 'pbfg-drawer__shot');
          var img = el('img');
          img.src = shot.url;
          img.alt = model.brand + ' ' + model.name +
                    (shot.label ? ' — ' + shot.label.toLowerCase() : ' — manufacturer render');
          img.loading = 'lazy';
          img.decoding = 'async';
          if (shot.fit === 'contain') fig.classList.add('pbfg-drawer__shot--contain');
          img.addEventListener('error', function () { fig.remove(); }, { once: true });
          fig.appendChild(img);
          if (shot.label) fig.appendChild(el('figcaption', null, shot.label));
          strip.appendChild(fig);
        });
        body.appendChild(strip);
      }

      if (model.url) {
        var link = el('a', 'pbfg-link');
        link.href = model.url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = 'Manufacturer specification';
        body.appendChild(link);
      }

      if (foot) {
        foot.textContent = Favourites.has(model.id) ? 'Saved to favourites' : 'Save to favourites';
        foot.onclick = function () {
          var added = Favourites.toggle(model);
          announce(Favourites.label(model) +
            (added ? ' saved to your favourites' : ' removed from your favourites'));
          closeDrawer();
        };
      }

      drawer.hidden = false;
      /* next frame so the CSS transition has a starting state to run from */
      window.requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
      releaseTrap = trapFocus(drawer, closeDrawer);
      var close = $('[data-pbfg-drawer-close]', drawer);
      if (close) close.focus();
    }

    function closeDrawer() {
      if (!drawer || drawer.hidden) return;
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (releaseTrap) { releaseTrap(); releaseTrap = null; }
      var finish = function () { drawer.hidden = true; };
      if (REDUCED) finish();
      else window.setTimeout(finish, 480);
      if (lastTrigger && document.body.contains(lastTrigger)) lastTrigger.focus();
    }

    if (drawer) {
      $$('[data-pbfg-drawer-close]', drawer).forEach(function (b) {
        b.addEventListener('click', closeDrawer);
      });
    }

    /* ---- deep links: ?brand=PENTARM  ?model=…  ?design=… ---------------- */

    function applyDeepLink() {
      var params = new URLSearchParams(window.location.search);
      var b = params.get('brand');
      if (b) {
        var match = null;
        tabs.forEach(function (t) {
          if (t.getAttribute('data-pbfg-tab').toLowerCase() === b.toLowerCase()) match = t;
        });
        if (match) { match.click(); }
      }
      var m = params.get('model');
      if (m) {
        var model = findModel(m);
        if (model) {
          Favourites.add(model);
          window.setTimeout(function () {
            var card = cardFor(model.id);
            if (card) card.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
          }, 260);
        }
      }

      /* ?design= is what "View this design" in the gallery lightbox uses.

         It lands the visitor ON THE CARD in the catalogue — the shell render
         with "Save to favourites" sitting right under it — rather than opening
         the details drawer over the top of it. Someone who followed a
         photograph here already knows what the pool looks like; what they want
         next is the button.

         It deliberately does not save anything for them. Following a link out
         of a photo is not choosing a pool. */
      var d = params.get('design');
      if (d) {
        var target = findModel(d);
        if (target) showCard(target);
      }
    }

    /* Model ids are our own slugs, but a card lookup should not fall over on a
       browser without CSS.escape — it just walks the grid instead. */
    function cardFor(id) {
      if (window.CSS && CSS.escape) return $('[data-model-id="' + CSS.escape(id) + '"]', grid);
      var found = null;
      $$('.pbfg-card', grid).forEach(function (c) {
        if (!found && c.getAttribute('data-model-id') === id) found = c;
      });
      return found;
    }

    function showCard(model) {
      /* Clear any filter that would hide the card before looking for it. A
         visitor arriving from the gallery has no filters set, but the theme
         editor can save a different starting state and a stale bfcache restore
         can bring one back — and a link that silently lands on nothing is
         worse than one that resets a filter nobody chose. */
      state.q = ''; state.size = ''; state.collection = ''; state.features = [];
      state.brand = 'all';
      if (searchInp) searchInp.value = '';
      if (sizeSel) sizeSel.value = '';
      $$('[data-pbfg-feature]', featureBox || document).forEach(function (i) { i.checked = false; });
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-pbfg-tab') === 'all';
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      buildCollectionOptions();
      render();

      window.setTimeout(function () {
        var card = cardFor(model.id);
        if (!card) return;

        card.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });

        /* Eighty-four cards look alike at a glance. Mark the one they asked
           for so it is obvious which of them the link meant. */
        card.classList.add('is-linked');
        window.setTimeout(function () { card.classList.remove('is-linked'); }, 5200);

        /* Put the keyboard on the save button, not the card. Whoever followed
           that link came to do one thing. */
        var save = $('[data-pbfg-select]', card);
        if (save) {
          window.setTimeout(function () {
            save.focus({ preventScroll: true });
          }, REDUCED ? 0 : 620);
        }
        announce(Favourites.label(model) +
          '. Save to favourites is below the image.');
      }, 260);
    }

    buildCollectionOptions();
    buildFeatureChips();
    render();
    applyDeepLink();

    /* The one-file review build cannot navigate to another page, so it calls
       this instead of re-implementing "View this design" and drifting from it.
       Prefixed PB_FG_ like every other global in this package, and it only
       reads — it cannot save a design on anyone's behalf. */
    window.PB_FG_SHOW_DESIGN = function (id) {
      var model = findModel(id);
      if (model) showCard(model);
      return !!model;
    };

    Favourites.on(function () { paintSelected(); });
  }

  /* =======================================================================
     SELECTION TRAY
     ======================================================================= */

  function initTray() {
    var tray = $('[data-pbfg-tray]');
    if (!tray) return;

    var thumb  = $('[data-pbfg-tray-thumb]', tray);
    var name   = $('[data-pbfg-tray-name]', tray);
    var meta   = $('[data-pbfg-tray-meta]', tray);
    var label  = $('[data-pbfg-tray-label]', tray);
    var remove = $('[data-pbfg-tray-remove]', tray);
    var review = $('[data-pbfg-tray-review]', tray);

    if (remove) {
      remove.addEventListener('click', function () {
        Favourites.clear();
        announce('Favourites cleared.');
      });
    }

    if (review) {
      review.addEventListener('click', function () { openFavourites(review); });
    }

    Favourites.on(function (fav) {
      var n = fav.items.length;
      if (!n) {
        tray.classList.remove('is-visible');
        tray.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('pbfg-tray-open');
        return;
      }

      var last = fav.items[n - 1];

      if (label) label.textContent = n === 1 ? 'Saved to favourites' : n + ' designs saved';
      if (name)  name.textContent  = n === 1 ? last.name : 'Your favourites';
      if (meta) {
        meta.textContent = n === 1
          ? [last.brand, last.collection, last.dims].filter(Boolean).join(' · ')
          : fav.items.slice(0, 3).map(function (m) { return m.name; }).join(', ') +
            (n > 3 ? ' and ' + (n - 3) + ' more' : '');
      }
      if (review) review.textContent = n === 1 ? 'View favourite' : 'View favourites (' + n + ')';

      if (thumb) {
        thumb.textContent = '';
        var url = last.cdn || ((window.PB_FG_CONFIG || {}).useManufacturerUrls ? last.src : '');
        thumb.hidden = !url;
        if (url) {
          var img = el('img');
          img.src = url; img.alt = ''; img.loading = 'lazy'; img.decoding = 'async';
          thumb.appendChild(img);
        }
      }

      tray.classList.add('is-visible');
      tray.setAttribute('aria-hidden', 'false');
      document.body.classList.add('pbfg-tray-open');
    });
  }

  /* Sub-nav favourites button. Lives on all three pages, so the customer can
     reach what they saved from the Gallery and the FAQ as well as the
     catalogue. The count is the only place on the page that says how many
     without opening anything. */
  function initFavouritesNav() {
    var buttons = $$('[data-pbfg-favourites-open]');
    if (!buttons.length) return;
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () { openFavourites(btn); });
    });
    Favourites.on(function (fav) {
      var n = fav.items.length;
      $$('[data-pbfg-favourites-count]').forEach(function (c) {
        c.textContent = String(n);
        c.hidden = n === 0;
      });
      buttons.forEach(function (btn) {
        btn.setAttribute('aria-label', n
          ? 'Favourites, ' + n + (n === 1 ? ' design saved' : ' designs saved')
          : 'Favourites, nothing saved yet');
      });
    });
  }

  /* Consultation panel. The nav item is a real link to the contact page, so
     this only takes over when JavaScript is there to offer something better. */
  function initContactPanel() {
    var panel = $('[data-pbfg-contact]');
    var triggers = $$('[data-pbfg-contact-open]');
    if (!panel || !triggers.length) return;

    var release = null;
    var opener = null;

    function close() {
      panel.classList.remove('is-open');
      window.setTimeout(function () { panel.hidden = true; }, REDUCED ? 0 : 300);
      panel.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (release) { release(); release = null; }
      if (opener && opener.focus) opener.focus();
    }

    triggers.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        opener = t;
        panel.hidden = false;
        panel.setAttribute('aria-hidden', 'false');
        window.requestAnimationFrame(function () { panel.classList.add('is-open'); });
        document.documentElement.style.overflow = 'hidden';
        release = trapFocus(panel, close);
      });
    });

    $$('[data-pbfg-contact-close]', panel).forEach(function (b) {
      b.addEventListener('click', function (e) {
        /* "Send an enquiry" is a real anchor — let it navigate, just close
           the panel on the way out. */
        if (b.tagName !== 'A') e.preventDefault();
        close();
      });
    });
  }

  /* =======================================================================
     FAVOURITES PANEL

     Somewhere to keep designs while browsing, and somewhere to see them
     together. It is not a basket and it does not commit anyone to anything:
     which pool actually gets built is settled with Pool Busters in person,
     once someone has seen the property. The copy says so rather than leaving
     the customer to guess.
     ======================================================================= */

  var openFavourites = function () {};

  function initFavouritesPanel() {
    var panel = $('[data-pbfg-cart]');
    if (!panel) return;

    var list    = $('[data-pbfg-cart-list]', panel);
    var status  = $('[data-pbfg-cart-status]', panel);
    var empty   = $('[data-pbfg-cart-empty]', panel);
    var clear   = $('[data-pbfg-cart-clear]', panel);
    var release = null;
    var opener  = null;

    function close() {
      panel.classList.remove('is-open');
      window.setTimeout(function () { panel.hidden = true; }, REDUCED ? 0 : 300);
      panel.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (release) { release(); release = null; }
      if (opener && opener.focus) opener.focus();
    }

    openFavourites = function (trigger) {
      opener = trigger || null;
      render();
      panel.hidden = false;
      panel.setAttribute('aria-hidden', 'false');
      window.requestAnimationFrame(function () { panel.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
      release = trapFocus(panel, close);
    };

    $$('[data-pbfg-cart-close]', panel).forEach(function (b) {
      b.addEventListener('click', close);
    });

    if (clear) {
      clear.addEventListener('click', function () {
        Favourites.clear();
        announce('Favourites cleared.');
        close();
      });
    }

    function render() {
      if (!list) return;
      list.textContent = '';

      Favourites.items.forEach(function (m) {
        var li = el('li', 'pbfg-cart__item');

        var fig = el('div', 'pbfg-cart__thumb');
        var url = m.cdn || '';
        if (url) {
          var img = el('img');
          img.src = url; img.alt = ''; img.loading = 'lazy'; img.decoding = 'async';
          fig.appendChild(img);
        } else { fig.hidden = true; }

        var body = el('div', 'pbfg-cart__body');
        var h = el('p', 'pbfg-cart__name'); h.textContent = Favourites.label(m);
        var mt = el('p', 'pbfg-cart__meta');
        mt.textContent = [m.collection, m.dims, m.depth].filter(Boolean).join(' · ');
        body.appendChild(h); body.appendChild(mt);

        var rm = el('button', 'pbfg-cart__remove');
        rm.type = 'button';
        rm.textContent = 'Remove';
        rm.setAttribute('aria-label', 'Remove ' + Favourites.label(m) + ' from your favourites');
        rm.addEventListener('click', function () {
          Favourites.remove(m.id);
          announce(Favourites.label(m) + ' removed from your favourites.');
          render();
        });

        li.appendChild(fig); li.appendChild(body); li.appendChild(rm);
        list.appendChild(li);
      });

      var n = Favourites.items.length;
      if (empty) empty.hidden = n > 0;
      if (clear) clear.hidden = n === 0;
      if (status) {
        status.textContent = n
          ? n + (n === 1 ? ' design saved' : ' designs saved')
          : '';
      }
    }

    Favourites.on(function () { if (!panel.hidden) render(); });
  }

  /* =======================================================================
     FORM — validation, hidden field population, duplicate prevention
     ======================================================================= */

  function initForm() {
    var form = $('[data-pbfg-form]');
    if (!form) return;

    var box      = $('[data-pbfg-form-selected]', form);
    var boxName  = $('[data-pbfg-form-name]', form);
    var boxMeta  = $('[data-pbfg-form-meta]', form);
    var submit   = $('[data-pbfg-submit]', form);

    function hidden(key) { return form.querySelector('[data-pbfg-hidden="' + key + '"]'); }

    /* The favourites go to Pool Busters as the starting point for a
       conversation, not as an order. Sent as a readable list plus the internal
       references, so whoever picks the enquiry up can look each one up without
       having to decode anything. */
    Favourites.on(function (fav) {
      var items = fav.items;
      var fields = {
        designs: items.map(function (m) {
          return Favourites.label(m) + (m.dims ? ' (' + m.dims + ')' : '');
        }).join('; '),
        designcount: items.length ? String(items.length) : '',
        designrefs: items.map(function (m) { return m.id; }).join(' ')
      };
      Object.keys(fields).forEach(function (k) {
        var input = hidden(k);
        if (input) input.value = fields[k];
      });

      if (box) box.classList.toggle('pbfg-form__selected--empty', !items.length);

      if (boxName) {
        boxName.textContent = !items.length
          ? 'No designs saved yet'
          : (items.length === 1 ? items[0].name : items.length + ' designs saved');
      }

      if (boxMeta) {
        if (!items.length) {
          boxMeta.textContent = 'Save designs from the catalogue above and they will appear here. ' +
            'You can send as many as you like — we work out which one suits your property together.';
        } else if (items.length === 1) {
          boxMeta.textContent = [items[0].brand, items[0].collection, items[0].dims]
            .filter(Boolean).join(' · ');
        } else {
          boxMeta.textContent = items.map(function (m) { return Favourites.label(m); }).join('  ·  ');
        }
      }
    });

    /* Page URL + timestamp, captured at load. */
    var pageField = hidden('page');
    if (pageField) pageField.value = window.location.origin + window.location.pathname;
    var timeField = hidden('submitted');
    if (timeField) timeField.value = new Date().toISOString();

    /* ---- validation ---------------------------------------------------- */

    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i;
    /* North American formats, tolerant of spaces, dashes, dots, brackets. */
    var PHONE_RE = /^(\+?1[\s.\-]?)?\(?\d{3}\)?[\s.\-]?\d{3}[\s.\-]?\d{4}$/;

    function errorNode(field) {
      var id = field.getAttribute('aria-describedby');
      return id ? document.getElementById(id) : null;
    }

    function setError(field, message) {
      var node = errorNode(field);
      if (node) node.textContent = message || '';
      if (message) field.setAttribute('aria-invalid', 'true');
      else field.removeAttribute('aria-invalid');
      return !message;
    }

    function validateField(field) {
      var value = (field.value || '').trim();
      var label = field.getAttribute('data-pbfg-label') || 'This field';

      if (field.hasAttribute('required')) {
        if (field.type === 'checkbox' && !field.checked) {
          return setError(field, 'Please confirm before submitting.');
        }
        if (field.type !== 'checkbox' && !value) {
          return setError(field, label + ' is required.');
        }
      }
      if (field.type === 'email' && value && !EMAIL_RE.test(value)) {
        return setError(field, 'Please enter a valid email address.');
      }
      if (field.type === 'tel' && value && !PHONE_RE.test(value)) {
        return setError(field, 'Please enter a valid phone number, for example 905 555 0123.');
      }
      return setError(field, '');
    }

    var fields = $$('[data-pbfg-validate]', form);
    fields.forEach(function (field) {
      field.addEventListener('blur', function () { validateField(field); });
      field.addEventListener('input', function () {
        if (field.getAttribute('aria-invalid') === 'true') validateField(field);
      });
    });

    /* ---- submit -------------------------------------------------------- */

    var submitted = false;

    form.addEventListener('submit', function (e) {
      /* Duplicate prevention: one submission per page view. */
      if (submitted) { e.preventDefault(); return; }

      var firstBad = null;
      fields.forEach(function (field) {
        if (!validateField(field) && !firstBad) firstBad = field;
      });

      if (firstBad) {
        e.preventDefault();
        firstBad.focus();
        firstBad.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
        announce('Please correct the highlighted fields before submitting.');
        return;
      }

      /* Client-side rate limit: refuse a second send within 60 seconds.
         This is a courtesy guard only — the real protection is the
         honeypot, the time trap and Shopify's own form handling. */
      try {
        var last = Number(window.sessionStorage.getItem('pbfg:lastSubmit') || 0);
        if (last && Date.now() - last < 60000) {
          e.preventDefault();
          announce('Your enquiry was already sent. Please wait a moment before sending another.');
          return;
        }
        window.sessionStorage.setItem('pbfg:lastSubmit', String(Date.now()));
      } catch (err) { /* ignore */ }

      submitted = true;
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Sending…';
      }
      /* The form now posts normally to Shopify's contact endpoint. */
    });

    /* Time trap: a bot that submits within 3 seconds of page load is caught
       server-side by comparing this value. Populated at load, checked in Liquid
       only for display; primary bot defence remains the honeypot. */
    var trap = hidden('elapsed');
    if (trap) {
      var t0 = Date.now();
      form.addEventListener('submit', function () {
        trap.value = String(Math.round((Date.now() - t0) / 1000));
      });
    }
  }

  /* =======================================================================
     GALLERY LIGHTBOX
     ======================================================================= */

  /* Build the gallery from the catalogue data rather than from hand-added
     section blocks. Every model already carries its own lifestyle photography
     in `filesExtra`, so the shots and their captions come from one source of
     truth — there is no second list to keep in step, and a photograph can
     never end up captioned with the wrong model because someone pasted it into
     the wrong block.

     Runs before initGallery so the lightbox and the filters, which both work
     off the rendered DOM, need no changes at all. */
  function buildGalleryFromModels() {
    var targets = $$('[data-pbfg-gallery-source="models"]');
    if (!targets.length || !window.PB_FG_MODELS) return;

    var unconfirmed = window.PB_FG_GALLERY_UNCONFIRMED || [];

    function shapeTag(shape) {
      var s = (shape || '').toLowerCase();
      if (s.indexOf('rectang') > -1 || s.indexOf('curved rect') > -1) return 'rectangular';
      if (s.indexOf('freeform') > -1 || s.indexOf('free form') > -1) return 'freeform';
      if (s.indexOf('kidney') > -1) return 'freeform';
      return '';
    }

    /* Best-looking first, using the order in the data file: hand-picked
       photographs lead, then the rest by measured quality. Anything not listed
       falls to the end rather than disappearing.

       One adjustment afterwards: if two neighbours are the same model, the
       second slides down. Three shots of the same pool in a row reads as a
       thin gallery even when every one of them is good. */
    function ordered() {
      var rank = {};
      (window.PB_FG_GALLERY_ORDER || []).forEach(function (f, i) { rank[f] = i; });
      var BOTTOM = 1e6;

      var out = [];
      window.PB_FG_MODELS.forEach(function (m) {
        (m.filesExtra || []).forEach(function (f, i) {
          out.push({ model: m, file: f, rank: rank[f] === undefined ? BOTTOM + i : rank[f] });
        });
      });
      out.sort(function (a, b) { return a.rank - b.rank; });

      for (var i = 1; i < out.length; i++) {
        if (out[i].model.id !== out[i - 1].model.id) continue;
        for (var j = i + 1; j < out.length; j++) {
          if (out[j].model.id === out[i - 1].model.id) continue;
          out.splice(i, 0, out.splice(j, 1)[0]);
          break;
        }
      }
      return out;
    }

    var items = ordered();

    targets.forEach(function (gallery) {
      var list = $('.pbfg-gallery', gallery);
      if (!list) return;
      var limit = parseInt(gallery.getAttribute('data-pbfg-gallery-limit'), 10);
      var frag = document.createDocumentFragment();
      var used = 0;

      items.forEach(function (it) {
        if (limit && used >= limit) return;
        var url = filesUrl(it.file) || it.model.cdn;
        if (!url) return;

        /* A model on this list has manufacturer photography that shows a
           DIFFERENT pool. Naming it would mislead, so it stays "Inspiration"
           and — importantly — carries no link through to a product it is not
           actually a picture of. */
        var named = unconfirmed.indexOf(it.model.id) === -1;
        var caption = named ? it.model.brand + ' ' + it.model.name : 'Inspiration';
        var alt = named
          ? 'A ' + it.model.brand + ' ' + it.model.name + ' fiberglass pool, installed'
          : 'An installed fiberglass pool';

        var tags = [it.model.brand.toLowerCase()];
        var sh = shapeTag(it.model.shape);
        if (sh) tags.push(sh);
        (it.model.tags || []).forEach(function (t) {
          if (tags.indexOf(t) === -1) tags.push(t);
        });

        var li  = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pbfg-shot';
        btn.setAttribute('data-pbfg-shot', '');
        btn.setAttribute('data-full', url);
        btn.setAttribute('data-caption', caption);
        btn.setAttribute('data-tags', tags.join(' '));
        if (named) {
          btn.setAttribute('data-brand', it.model.brand);
          btn.setAttribute('data-name', it.model.name);
          btn.setAttribute('data-model-id', it.model.id);
        }
        btn.setAttribute('aria-label', 'View larger: ' + alt);

        var img = document.createElement('img');
        img.src = url;
        img.alt = alt;
        img.loading = 'lazy';
        img.decoding = 'async';
        img.width = 800; img.height = 600;

        /* Two lines, same as the viewer: brand above, model below. An
           unconfirmed photo has no model to name, so it gets the single
           "Inspiration" line and no brand. */
        var cap = document.createElement('span');
        cap.className = 'pbfg-shot__cap';
        if (named) cap.appendChild(el('span', 'pbfg-shot__brand', it.model.brand));
        cap.appendChild(el('span', 'pbfg-shot__name', named ? it.model.name : caption));

        btn.appendChild(img); btn.appendChild(cap);
        li.appendChild(btn); frag.appendChild(li);
        used++;
      });

      list.appendChild(frag);
      var counter = $('[data-pbfg-gallery-count]', gallery);
      if (counter) counter.textContent = used + (used === 1 ? ' image' : ' images');
    });
  }

  function initGallery() {
    var galleries = $$('[data-pbfg-gallery]');
    if (!galleries.length) return;

    var lb = $('[data-pbfg-lightbox]');
    if (!lb) return;

    /* liftOverlays() in boot() has already moved this to <body> — see there
       for why that matters. */


    var lbImg  = $('[data-pbfg-lb-img]', lb);
    var lbCap  = $('[data-pbfg-lb-cap]', lb);
    var lbBrand = $('[data-pbfg-lb-brand]', lb);
    var lbName  = $('[data-pbfg-lb-name]', lb);
    var lbLink  = $('[data-pbfg-lb-link]', lb);
    var prevBtn = $('[data-pbfg-lb-prev]', lb);
    var nextBtn = $('[data-pbfg-lb-next]', lb);

    /* Where "View this design" points. Set on the caption by the section so a
       merchant can move the Design Centre without touching this file. */
    var dcUrl = (lbCap && lbCap.getAttribute('data-pbfg-lb-dc')) ||
                '/pages/fiberglass-design-centre';

    var shots = [];
    var index = 0;
    var release = null;
    var opener = null;

    function collect(gallery) {
      shots = $$('[data-pbfg-shot]', gallery).filter(function (s) {
        return s.offsetParent !== null;
      });
    }

    function show(i) {
      if (!shots.length) return;
      index = (i + shots.length) % shots.length;
      var shot = shots[index];
      var img = $('img', shot);
      lbImg.removeAttribute('style');
      lbImg.src = shot.getAttribute('data-full') || (img ? img.currentSrc || img.src : '');
      lbImg.alt = img ? img.alt : '';
      paintCaption(shot);
      sizeToSource();
      announce('Image ' + (index + 1) + ' of ' + shots.length);
    }

    /* Brand on one line, model on the next, then the way through to the
       design. Falls back to the flat `data-caption` string for galleries built
       from manual image blocks, which have no model behind them — those get a
       caption and no link, because there is nothing to link to. */
    function paintCaption(shot) {
      var brand = shot.getAttribute('data-brand');
      var name  = shot.getAttribute('data-name');
      var id    = shot.getAttribute('data-model-id');

      if (lbBrand && lbName) {
        lbBrand.textContent = brand || '';
        lbBrand.hidden = !brand;
        lbName.textContent = name || shot.getAttribute('data-caption') || '';
      } else {
        lbCap.textContent = shot.getAttribute('data-caption') || '';
        return;
      }

      if (!lbLink) return;
      if (id) {
        lbLink.href = dcUrl + '?design=' + encodeURIComponent(id) + '#pbfg-catalogue';
        lbLink.hidden = false;
        lbLink.setAttribute('aria-label',
          'View this design: ' + (brand ? brand + ' ' : '') + (name || ''));
      } else {
        lbLink.hidden = true;
        lbLink.removeAttribute('href');
      }
    }

    /* Manufacturer photographs run 768–1536px wide. Stretching a 900px photo
       across 1400px of screen is what made them look soft, but showing it at
       exactly 900px wastes a big screen. So: enlarge, but only up to 1.4x —
       past that the softness starts to show. Applied per image, because the
       right size depends on the file, not on the viewport alone. */
    var MAX_UPSCALE = 1.4;

    function apply() {
      if (!lbImg.naturalWidth) return;

      /* Enlarging by width alone is what pushed the caption off the bottom of
         a short window: a 1200px photo scaled to 1680px is also 1260px tall.
         So cap the width by the height actually left over once the caption has
         taken what it needs, and let the caption keep its space. */
      var figure = lbImg.parentNode;
      var capHeight = lbCap ? lbCap.offsetHeight : 0;
      var gap = figure ? parseFloat(getComputedStyle(figure).rowGap) || 0 : 0;
      var padding = figure
        ? parseFloat(getComputedStyle(figure).paddingTop) * 2
        : 0;
      var room = (figure ? figure.clientHeight : lb.clientHeight) -
                 capHeight - gap - padding;

      var ratio = lbImg.naturalWidth / lbImg.naturalHeight;
      var byHeight  = room > 0 ? room * ratio : Infinity;
      var byUpscale = lbImg.naturalWidth * MAX_UPSCALE;

      /* `width`, not `max-width` — max-width can only shrink an image, and
         the point here is to enlarge it. The CSS caps still apply. */
      lbImg.style.width = Math.max(200, Math.round(Math.min(byHeight, byUpscale))) + 'px';
    }

    function sizeToSource() {
      if (lbImg.complete && lbImg.naturalWidth) apply();
      else lbImg.addEventListener('load', apply, { once: true });
    }

    /* Turning a phone sideways changes how much room there is, and the caption
       must survive it. Cheap enough to run straight through. */
    window.addEventListener('resize', function () {
      if (!lb.hidden) apply();
    });

    function open(gallery, shot) {
      collect(gallery);
      opener = shot;
      /* Unhide BEFORE sizing. While the viewer is display:none every height
         reads as zero, so the sizing pass has nothing to divide the space
         between and the caption loses. */
      lb.hidden = false;
      show(shots.indexOf(shot));
      window.requestAnimationFrame(function () { lb.classList.add('is-open'); });
      document.documentElement.style.overflow = 'hidden';
      release = trapFocus(lb, close);
      var closeBtn = $('[data-pbfg-lb-close]', lb);
      /* preventScroll: focus must not be allowed to move the page underneath
         the viewer — the customer scrolls back to where they were otherwise. */
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    function close() {
      lb.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      if (release) { release(); release = null; }
      var finish = function () { lb.hidden = true; lbImg.removeAttribute('src'); };
      if (REDUCED) finish(); else window.setTimeout(finish, 380);
      if (opener && document.body.contains(opener)) opener.focus();
    }

    galleries.forEach(function (gallery) {
      gallery.addEventListener('click', function (e) {
        var shot = e.target.closest('[data-pbfg-shot]');
        if (shot) open(gallery, shot);
      });
    });

    /* Navigate explicitly rather than trusting the browser's default.

       This link lives inside a modal, and host themes and third-party apps
       routinely bind a delegated handler to every anchor on the page — for
       smooth scrolling, for analytics, for closing their own overlays. If one
       of those calls preventDefault(), the customer clicks "View this design"
       and nothing happens at all.

       preventDefault() ourselves and set location by hand: whatever else is
       listening, the navigation is now ours to perform. Modifier clicks are
       left alone so open-in-new-tab still behaves normally. */
    if (lbLink) {
      lbLink.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        var href = lbLink.getAttribute('href');
        if (!href || href.charAt(0) === '#') return;
        e.preventDefault();
        window.location.href = href;
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); });
    $$('[data-pbfg-lb-close]', lb).forEach(function (b) {
      b.addEventListener('click', close);
    });

    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); show(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
    });

    /* Swipe — horizontal only, with a vertical-intent guard. */
    var sx = 0, sy = 0, tracking = false;
    lb.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
    }, { passive: true });

    lb.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 56 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        show(dx < 0 ? index + 1 : index - 1);
      }
    }, { passive: true });

    /* Gallery filters (brand / category), scoped to their own gallery so a
       preview and a full gallery can coexist without fighting each other. */
    galleries.forEach(function (gallery) {
      var filterBtns = $$('[data-pbfg-gallery-filter]', gallery);
      if (!filterBtns.length) return;

      filterBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var key = btn.getAttribute('data-pbfg-gallery-filter');
          filterBtns.forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          var shown = 0;
          $$('[data-pbfg-shot]', gallery).forEach(function (shot) {
            var tags = (shot.getAttribute('data-tags') || '').split(' ');
            var visible = key === 'all' || tags.indexOf(key) > -1;
            var item = shot.closest('li') || shot;
            item.hidden = !visible;
            if (visible) shown++;
          });
          var counter = $('[data-pbfg-gallery-count]', gallery);
          if (counter) counter.textContent = shown + (shown === 1 ? ' image' : ' images');
          announce(shown + (shown === 1 ? ' image' : ' images') + ' shown');
        });
      });
    });
  }

  /* =======================================================================
     FAQ — accordions, search, categories
     ======================================================================= */

  function initFaq() {
    /* Each FAQ section manages only its own questions. A three-question
       preview and a full FAQ can therefore sit on the same page — or in the
       same preview file — without one filtering the other's content. */
    var roots = $$('[data-pbfg-faq-root]');
    if (!roots.length) roots = [document];

    roots.forEach(function (root) {
      var accordions = $$('[data-pbfg-acc]', root);

      accordions.forEach(function (acc) {
        var btn   = $('[data-pbfg-acc-btn]', acc);
        var panel = $('[data-pbfg-acc-panel]', acc);
        if (!btn || !panel) return;

        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          panel.classList.toggle('is-open', !open);
          panel.hidden = false; /* height is animated, content stays in the a11y tree */
        });
      });

      var search   = $('[data-pbfg-faq-search]', root);
      var noneMsg  = $('[data-pbfg-faq-empty]', root);
      var faqCount = $('[data-pbfg-faq-count]', root);
      var catBtns  = $$('[data-pbfg-faq-cat]', root);
      var activeCat = 'all';

      function applyFilters() {
        var q = search ? search.value.trim().toLowerCase() : '';
        var shown = 0;

        accordions.forEach(function (acc) {
          var text = (acc.textContent || '').toLowerCase();
          var cat  = acc.getAttribute('data-category') || '';
          var okQ  = !q || text.indexOf(q) > -1;
          var okC  = activeCat === 'all' || cat === activeCat;
          var visible = okQ && okC;
          acc.hidden = !visible;
          if (visible) shown++;
        });

        if (noneMsg) noneMsg.hidden = shown !== 0;
        if (faqCount) faqCount.textContent = shown + (shown === 1 ? ' question' : ' questions');
        announce(shown + (shown === 1 ? ' question' : ' questions') + ' shown');
      }

      var faqTimer;
      if (search) {
        search.addEventListener('input', function () {
          window.clearTimeout(faqTimer);
          faqTimer = window.setTimeout(applyFilters, 180);
        });
      }

      catBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          activeCat = btn.getAttribute('data-pbfg-faq-cat');
          catBtns.forEach(function (b) {
            b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
          });
          applyFilters();
        });
      });

      if (search || catBtns.length) applyFilters();
    });
  }

  /* =======================================================================
     HERO VIDEO — pause offscreen, respect reduced motion
     ======================================================================= */

  function initHeroVideo() {
    var video = $('[data-pbfg-hero-video]');
    if (!video) return;

    if (REDUCED) {
      video.pause();
      video.removeAttribute('autoplay');
      video.hidden = true;
      var poster = $('[data-pbfg-hero-poster]');
      if (poster) poster.hidden = false;
      return;
    }

    var play = function () {
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* autoplay blocked — poster shows */ });
    };

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) play();
          else video.pause();
        });
      }, { threshold: 0.1 });
      io.observe(video);
    } else {
      play();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) video.pause(); else play();
    });
  }

  /* ------------------------------------------------------------- bootstrap */

  /* =======================================================================
     LIFT THE OVERLAYS

     Five things in this package are position:fixed — the favourites bar, the
     favourites panel, the consultation panel, the details drawer and the image
     viewer. `fixed` means "positioned against the viewport" only while no
     ancestor has a transform, filter, perspective or contain on it. Any one of
     those silently redefines it as "positioned against THAT ancestor", and the
     panel is then sized and placed against the whole document instead of the
     screen: a drawer taller than the page with its content far above the fold,
     a viewer whose photograph sits thousands of pixels down.

     We cannot know what the surrounding theme does — Debut transforms its page
     container to slide the mobile drawer, and plenty of apps add their own
     wrappers. So move all five to <body>, once, before anything reads them.
     ======================================================================= */

  function liftOverlays() {
    ['[data-pbfg-tray]', '[data-pbfg-cart]', '[data-pbfg-contact]',
     '[data-pbfg-drawer]', '[data-pbfg-lightbox]'].forEach(function (sel) {
      $$(sel).forEach(function (node) {
        /* Move the .pbfg WRAPPER, not the panel itself.

           Every colour in this package is a custom property declared on .pbfg
           — background: var(--pbfg-ivory) and so on. Lift the panel out on its
           own and it lands outside that scope, every variable resolves to
           nothing, and the panel renders with no background at all: readable
           text floating over the page behind it. Each of these overlays is
           wrapped in its own .pbfg containing nothing else, so moving the
           wrapper takes the styling with it. */
        var host = node.closest ? (node.closest('.pbfg') || node) : node;
        if (host.parentNode !== document.body) document.body.appendChild(host);
      });
    });
  }

  function boot() {
    /* Load FIRST. Everything else that touches favourites — the catalogue's
       saved-card painting, the bar, the panel, the nav count — registers a
       listener that fires immediately with whatever the store holds at that
       moment. Load after any of them and they all start from empty, which is
       what made saved designs vanish on reload. */
    /* Before anything else reads or measures them. */
    liftOverlays();

    Favourites.load();

    initReveals();
    initCatalogue();
    initTray();
    initFavouritesPanel();
    initFavouritesNav();
    initContactPanel();
    initForm();
    buildGalleryFromModels();
    initGallery();
    initFaq();
    initHeroVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
